import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Container,
  Button,
} from "reactstrap";
import MetaTags from "react-meta-tags";

//Import Breadcrumb
import Breadcrumbs from "../../components/common/Breadcrumb";
import "../../../src/assets/scss/custom/plugins/_datatables.scss";
import { ApiCore } from "../../helpers/api_helper";
import { Loading } from "../../components/common/Loading";
import { AxiosResponse } from "axios";
import { Endpoints } from "../../utils/Endpoints";
import { XTextBox } from "../../components/common/inputs/XTextBox";
import { FieldArray, Form, Formik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { XSelect } from "../../components/common/inputs/XSelect";
import { getForms } from "../../utils/Helpers";
import { XCheckbox } from "../../components/common/inputs/XCheckbox";
import { XSearchableSelect } from "../../components/common/inputs/XSearchableSelect";

const CummulativeReport = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingMarktypes, setLoadingMarktypes] = useState<boolean>(true);
  const [marktypes, setMarktypes] = useState<any>([]);
  const [initialValues, setInitialValues] = useState<any>({
    student_id: "",
    stream: "",
    term: "",
    label: "END OF TERM"
  });
  const [data, setData] = useState<any>(null);

  const ref = React.useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState("0px");
  const onLoad = () => {
    console.log("scrolled");
  };

  useEffect(() => {
    request
      .get(Endpoints.marktypes, {})
      .then((response: AxiosResponse) => {
        const { marktypes } = response.data;
        setMarktypes(marktypes);
        setLoadingMarktypes(false);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const request = new ApiCore();

  const terms = [
    { value: "I", text: "I" },
    { value: "II", text: "II" },
    { value: "III", text: "III" },
  ];

  const categories = [
    { value: "assesment", text: "Assessment" },
    { value: "exam", text: "Exam" },
    { value: "mid term", text: "Mid term" },
    { value: "custom", text: "Custom" },
    { value: "pre-primary", text: "Pre-primary" },
  ];

  const getStudentsEndpoint = (values: any) => {
    let url = Endpoints.students + "?";

    if (values.form) {
      url += `form=${values.form}&`;
    }

    if (values.stream) {
      url += `stream=${values.stream}&`;
    }

    url = url.replace(/&$/, "");

    return url;
  }

  const handleSubmit = (values: any) => {
    setInitialValues(values);
    if (!values.html || values.html != 1) {
      delete values.html;
    }
    toast
      .promise(request.get(Endpoints.cummulativereport, { params: values }, values.html ? "json" : "arraybuffer"), {
        pending: "Please wait..",
        success: {
          render({ data }) {
            return "The report is ready";
          },
        },
        error: {
          render({ data }) {
            return data;
          },
        },
      })
      .then((response: AxiosResponse) => {
        console.log(response);
        if (values.html) {
          setData(response.data);
        } else {
          const type = response.headers['content-type']
          const blob = new Blob([response.data], { type: type })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `report-${values.form}-${values.stream}-${values.year}-${values.term}.pdf`
          link.click()
        }
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cummulative Report - Treda</title>
        </MetaTags>

        <Container fluid>
          <Breadcrumbs title="Marks" breadcrumbItem="List" />
          <Row>
            <Col md={12} lg={12} xl={12}>
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">Cummulative Reports</CardTitle>
                </CardHeader>
                <CardBody>
                  {loading || loadingMarktypes && <Loading label="Loading marks. Please wait." />}
                  {!loading && !loadingMarktypes && (
                    <>
                      <Row className="mb-2">
                        <Col xl="12">
                          <ToastContainer />
                        </Col>
                      </Row>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({
                          isSubmitting,
                          setFieldValue,
                          values,
                          errors,
                          touched,
                        }) => (
                          <>
                            <Form>
                              <Row>
                                <Col lg={2}>
                                  <XSearchableSelect
                                    allowAddNew={false}
                                    dataSrc={getStudentsEndpoint(values)}
                                    dataType={"students"}
                                    labelField="fullname"
                                    id="student_id"
                                    name="student_id"
                                    value="student_id"
                                    onChange={(value: any) => {
                                      setFieldValue("student_id", value.value);
                                    }}
                                    label="Student"
                                    touched={touched}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="form"
                                    id="form"
                                    name={"form"}
                                    options={getForms()}
                                    label={"Class"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XTextBox
                                    type="text"
                                    key="stream"
                                    id="stream"
                                    name={"stream"}
                                    label={"Stream"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XSelect
                                    key="term"
                                    id="term"
                                    name={"term"}
                                    options={terms}
                                    label={"Term"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={1}>
                                  <XTextBox
                                    type="text"
                                    key="year"
                                    id="year"
                                    name={"year"}
                                    label={"Year"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="category"
                                    id="category"
                                    name={"category"}
                                    options={categories}
                                    label={"Report Type"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <FieldArray
                                  name="marktypes"
                                  render={arrayHelpers => (
                                    <>
                                      {marktypes && marktypes.map((item: any, index: number) => {
                                        return <Col lg={1} key={index}>
                                          <XCheckbox
                                            key={`marktypes.${index}`}
                                            id={`marktypes.${index}`}
                                            name={`marktypes`}
                                            label={item.label}
                                            value={item.id}
                                            checked={values.marktypes && values.marktypes.includes(item.id)}
                                            includeTopPadding={true}
                                            onChange={(field: any, value: any) => {
                                              if (value && value > 0) {
                                                arrayHelpers.push(item.id)
                                              } else {
                                                const idx = values.marktypes.indexOf(item.id);
                                                arrayHelpers.remove(idx);
                                              }
                                            }}
                                            size={{}}
                                          />
                                        </Col>
                                      })}
                                    </>
                                  )}
                                />
                              </Row><br/>
                              <Row>
                                <Col lg={2}>
                                  <XCheckbox
                                    key="html"
                                    id="html"
                                    name={"html"}
                                    label={"Preview"}
                                    value="1"
                                    includeTopPadding={true}
                                    onChange={setFieldValue}
                                    checked={values.html == 1}
                                    size={{}}
                                  />
                                </Col>
                                <Col lg={4}>
                                  <XTextBox
                                    type="text"
                                    key="label"
                                    id="label"
                                    name={"label"}
                                    label={"Label"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <div>&nbsp;</div>
                                  <Button
                                    disabled={false}
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Next
                                  </Button>
                                </Col>
                              </Row>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {data && (
            <Row>
              <Col md={12} lg={12} xl={12}>
                <Card>
                  <CardBody>
                    <iframe ref={ref} srcDoc={data} width="100%" height="800px" />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CummulativeReport;
